import Contact from "./Contact"
import Login from "./Login"
import ResetPassword from "./ResetPassword"

export default {
  Contact,
  Login,
  ResetPassword,
}
